module.exports = __webpack_public_path__ + "img/comingSoon.94f06ac9.gif";